import api from './api'

type QuickMessageRecord = {
  id: number
}

/**
 * El selector del chat necesita todas las respuestas visibles para buscar
 * localmente mientras el operador escribe. El endpoint /list obtiene el tenant
 * y el usuario desde el JWT y devuelve la lista completa en una sola consulta.
 */
export const listAllQuickMessages = async <
  T extends QuickMessageRecord = QuickMessageRecord,
>(): Promise<T[]> => {
  const { data } = await api.get('/quick-messages/list')
  const records = Array.isArray(data) ? (data as T[]) : []

  return Array.from(
    new Map(records.map((record) => [record.id, record])).values(),
  )
}
